import "./levelUp.css"
import {usePumpStore} from "../../store/pumpStore";
import {levels} from "../../helpers/levelHelpers";
import check from "../../pages/task/check.svg";
import React, {useEffect} from "react";
import ConfettiExplosion from "react-confetti-explosion";
import {Locales} from "../../helpers/localeHelpers";
import parse from "html-react-parser";


const largeProps = {
    force: 0.6,
    duration: 2000,
    particleCount: 200,
    width: 2500,
    colors: ['#041E43', '#1471BF', '#5BB4DC', '#FC027B', '#66D805'],
};

export const LevelUp = () => {
    const {level, tasksCount, isExploding, setIsExploding, setScreenLayout, language} = usePumpStore()

    useEffect(() => {
        setIsExploding(true)
    }, []);

    return (
        <div className={"level_wrapper"}>
            {isExploding && <ConfettiExplosion {...largeProps} />}
            <p>Поздравляем</p>
            <div className={"level_wrapper__tasks"}>
                <img className="level_wrapper__tasks_icon" alt="Vector" src={check} />
                <div className="level_wrapper__tasks_number">{tasksCount}</div>
            </div>
            <p style={{fontSize: 16, color: '#39E476'}}>{parse(Locales[language].levelCorrect)}</p>
            <p style={{fontSize: 16, marginTop: 30}}>{parse(Locales[language].levelNewStatus)}</p>
            <img src={levels[level].active} alt={''} />
            <h4>{levels[level].name}</h4>
            <p style={{fontSize: 16, marginTop: 20, textAlign: "center"}}>{parse(Locales[language].levelWill)}</p>
            <div className={"multiplicator"}>x {levels[level].multiplicator}</div>
            <div className={`constructor__button`} onClick={() => setScreenLayout('task')}>Ok</div>
        </div>
    )
}